// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard_partts{
    display: flex;
    /* justify-content: space-between; */
    flex-wrap: wrap;
    margin: 0 -10px;
}
.wizard_inner{
    padding: 0 10px;
    max-width: calc(100%/4);
    width: 100%;
    margin-bottom: 30px;
    /*  */
    

}

.wizard_inner.click .wizard_inner_inner{
    background: #ed5565;
    width: 100%;
    /* height: 100%; */
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    overflow: hidden;
    position: relative;

}

.wizard_inner.commissions .wizard_inner_inner{
    background: #1ab394;
    width: 100%;
    /* height: 100%; */
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    overflow: hidden;
    position: relative;

}

.wizard_inner.impressions .wizard_inner_inner{
    background: #f8ac59;
    width: 100%;
    /* height: 100%; */
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    overflow: hidden;
    position: relative;

}

.wizard_inner.refund .wizard_inner_inner{
    background: #1c84c6;
    width: 100%;
    /* height: 100%; */
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    overflow: hidden;
    position: relative;

}
.wizard_inner_inner{
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0,0,0,0.3);
    overflow: hidden;
    position: relative;
    padding: 40px 0 20px 0;
    height: 100%;
}
.wizard_inner img{
}

.wizard_overlay{
    padding: 10px;
    font-size: 28px;
    color: #111;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
}

.wizard_overlay h3{
    font-size: 34px;
    font-weight: 600;
    color: #fff;
    margin-bottom: 10px;
}

.wizard_overlay p{
    font-size: 14px;
    font-weight: 400;
    text-transform: uppercase;
    margin-bottom: 20px;
    color: #fff;
    min-height: 40px;
}

.wizard_overlay img{
    filter: brightness(0) invert(1);
}

.wizard_overlay img{
    height: 60px;
}

.chart_partts{
    margin-top: 60px;
}

.select_month, .select_month.show{
    border: 1px solid #1c84c6 !important;
    background: transparent !important;
    color: #000 !important;
    font-size: 14px;
    font-weight: 600;
}

.affiliate_table_partts{
    margin-top: 60px;
}
.chart_partts{
    padding: 0 100px;
}

.affiliate_table_partts h2{
    margin-bottom: 50px;
}

.earned_amnt_chhhartt{
    max-width: 350px;
    width: 100%;
}

.border_earned{
    border: 1px solid #000;
    border-radius: 10px;
    height: 40px;
    width: 100%;
}

.copy_but{
    background: #004aad;
    color: #fff;
    font-weight: 600;
    font-size: 16px;
    border: 0;
    margin-left: 10px;
    border-radius: 10px;
    padding: 0 20px;
    height: 40px;
}
@media screen and (max-width:1199px){
    .wizard_inner{
        max-width: calc(100%/2);
    }

    .chart_partts{
        padding: 0 0px;
    }
    .earned_amnt_chhhartt{
        max-width: 100%;
    }

    .date__form{
        max-width: 100%;
        width: 100%;
        display: block !important;
    }

    .md-mb-3{
        margin-bottom: 20px;
    }
}

@media screen and (max-width:480px){
    .wizard_inner{
        max-width: calc(100%/1);
    }
    .chart_heading {
        display: block !important;
        text-align: center !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/affiliate-dashboard/affiliate-dashboard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,eAAe;AACnB;AACA;IACI,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,mBAAmB;IACnB,KAAK;;;AAGT;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;;AAEtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;AAChB;AACA;AACA;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;AACA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;QACzB,6BAA6B;IACjC;AACJ","sourcesContent":[".wizard_partts{\n    display: flex;\n    /* justify-content: space-between; */\n    flex-wrap: wrap;\n    margin: 0 -10px;\n}\n.wizard_inner{\n    padding: 0 10px;\n    max-width: calc(100%/4);\n    width: 100%;\n    margin-bottom: 30px;\n    /*  */\n    \n\n}\n\n.wizard_inner.click .wizard_inner_inner{\n    background: #ed5565;\n    width: 100%;\n    /* height: 100%; */\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    overflow: hidden;\n    position: relative;\n\n}\n\n.wizard_inner.commissions .wizard_inner_inner{\n    background: #1ab394;\n    width: 100%;\n    /* height: 100%; */\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    overflow: hidden;\n    position: relative;\n\n}\n\n.wizard_inner.impressions .wizard_inner_inner{\n    background: #f8ac59;\n    width: 100%;\n    /* height: 100%; */\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    overflow: hidden;\n    position: relative;\n\n}\n\n.wizard_inner.refund .wizard_inner_inner{\n    background: #1c84c6;\n    width: 100%;\n    /* height: 100%; */\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    overflow: hidden;\n    position: relative;\n\n}\n.wizard_inner_inner{\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.3);\n    overflow: hidden;\n    position: relative;\n    padding: 40px 0 20px 0;\n    height: 100%;\n}\n.wizard_inner img{\n}\n\n.wizard_overlay{\n    padding: 10px;\n    font-size: 28px;\n    color: #111;\n    font-weight: 500;\n    text-transform: uppercase;\n    text-align: center;\n}\n\n.wizard_overlay h3{\n    font-size: 34px;\n    font-weight: 600;\n    color: #fff;\n    margin-bottom: 10px;\n}\n\n.wizard_overlay p{\n    font-size: 14px;\n    font-weight: 400;\n    text-transform: uppercase;\n    margin-bottom: 20px;\n    color: #fff;\n    min-height: 40px;\n}\n\n.wizard_overlay img{\n    filter: brightness(0) invert(1);\n}\n\n.wizard_overlay img{\n    height: 60px;\n}\n\n.chart_partts{\n    margin-top: 60px;\n}\n\n.select_month, .select_month.show{\n    border: 1px solid #1c84c6 !important;\n    background: transparent !important;\n    color: #000 !important;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.affiliate_table_partts{\n    margin-top: 60px;\n}\n.chart_partts{\n    padding: 0 100px;\n}\n\n.affiliate_table_partts h2{\n    margin-bottom: 50px;\n}\n\n.earned_amnt_chhhartt{\n    max-width: 350px;\n    width: 100%;\n}\n\n.border_earned{\n    border: 1px solid #000;\n    border-radius: 10px;\n    height: 40px;\n    width: 100%;\n}\n\n.copy_but{\n    background: #004aad;\n    color: #fff;\n    font-weight: 600;\n    font-size: 16px;\n    border: 0;\n    margin-left: 10px;\n    border-radius: 10px;\n    padding: 0 20px;\n    height: 40px;\n}\n@media screen and (max-width:1199px){\n    .wizard_inner{\n        max-width: calc(100%/2);\n    }\n\n    .chart_partts{\n        padding: 0 0px;\n    }\n    .earned_amnt_chhhartt{\n        max-width: 100%;\n    }\n\n    .date__form{\n        max-width: 100%;\n        width: 100%;\n        display: block !important;\n    }\n\n    .md-mb-3{\n        margin-bottom: 20px;\n    }\n}\n\n@media screen and (max-width:480px){\n    .wizard_inner{\n        max-width: calc(100%/1);\n    }\n    .chart_heading {\n        display: block !important;\n        text-align: center !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
